import { render, staticRenderFns } from "./80.vue?vue&type=template&id=1fa48194&scoped=true&"
var script = {}
import style0 from "./80.vue?vue&type=style&index=0&id=1fa48194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa48194",
  null
  
)

export default component.exports